jQuery(document).on('ready', function(){
	YOUTUBE.onReady();
});



var YOUTUBE = {
	onReady: function(){
		jQuery(document).on('click', '.video-play.youtube', YOUTUBE.initYoutube);
		jQuery('.video').on('click', '.close.youtube', YOUTUBE.stopYoutube);
	},



	initYoutube: function(){
		// YOUTUBE.context 	= jQuery(this).closest('.video');
		YOUTUBE.context 	= jQuery(event.target).closest('.video');
		// YOUTUBE.id 			= jQuery(this).attr('data-ytid');
		YOUTUBE.id 			= jQuery(YOUTUBE.context).attr('data-ytid');
		YOUTUBE.container 	= jQuery('.video-container', YOUTUBE.context);

		if(jQuery('body').hasClass('youtube-ready')){
			YOUTUBE.initPlayer();
		} else {
			jQuery.getScript( "//www.youtube.com/player_api"); //API laden
		}
	},



	initPlayer : function(){
		jQuery(YOUTUBE.context).addClass('is-playing');
		jQuery(YOUTUBE.container).addClass('has-ratio');
		jQuery(YOUTUBE.container).parent().removeClass('is-hidden');
		jQuery('.video-info', YOUTUBE.context).addClass('is-hidden');
		jQuery('.video-play', YOUTUBE.context).addClass('is-hidden');
		jQuery('.video .video-sponsor', YOUTUBE.context).hide('is-hidden');
		jQuery('.video .close', YOUTUBE.context).removeClass('vimeo').addClass('youtube');
		
		if (typeof player !== "undefined"){
			player.destroy();
			player = null;
		}
		
  		var eventsVar = {
			'onReady': onPlayerReady, //Call Autoplay
			'onStateChange': onPlayerStateChange //Redirect after Video Ends
		};

		player = new YT.Player(YOUTUBE.container.attr('id'), {//DIV #player wird angesprochen
					width: YOUTUBE.context.outerWidth(), /* Breite des Players über CSS auf 100% */
					height: YOUTUBE.context.outerHeight(),  /*Höhe des Players wird per JS errechnet */
					videoId: YOUTUBE.id, //Video ID von Youtube eintragen (wp_localize_script())
					events: {
						'onReady': onPlayerReady, //Call Autoplay
						'onStateChange': onPlayerStateChange //Redirect after Video Ends
					}
		});

		// jQuery('html, body').animate({
	 //        scrollTop: 0
	 //    }, 800);
	},


	stopYoutube: function(){
		player.stopVideo();
	}
}



function onYouTubePlayerAPIReady() { 
	jQuery('body').addClass('youtube-ready');
	
	YOUTUBE.initPlayer();
}



function onPlayerReady(event) {
	event.target.playVideo();
}


function onPlayerStateChange(event) {        

}
